var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfile2User = function SvgProfile2User(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A2AEBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.633 9.058a1.515 1.515 0 0 0-.275 0A3.683 3.683 0 0 1 3.8 5.367c0-2.042 1.65-3.7 3.7-3.7a3.696 3.696 0 0 1 .133 7.392ZM13.675 3.333a2.915 2.915 0 0 1 2.917 2.917 2.92 2.92 0 0 1-2.809 2.917.94.94 0 0 0-.216 0M3.467 12.133c-2.017 1.35-2.017 3.55 0 4.892 2.291 1.533 6.05 1.533 8.341 0 2.017-1.35 2.017-3.55 0-4.892-2.283-1.525-6.041-1.525-8.341 0ZM15.283 16.667a4.03 4.03 0 0 0 1.634-.725c1.3-.975 1.3-2.584 0-3.559-.459-.35-1.017-.583-1.609-.716"
  })));
};
export default SvgProfile2User;